//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data: function data() {
    return {};
  },
  props: {
    thememobile: {
      type: Object | Array
    }
  }
};